import { createContext } from 'react'

export const HistoryStoreContext = createContext(null)
